'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HardwareTabletAndroid = function HardwareTabletAndroid(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M18 0H6C4.34 0 3 1.34 3 3v18c0 1.66 1.34 3 3 3h12c1.66 0 3-1.34 3-3V3c0-1.66-1.34-3-3-3zm-4 22h-4v-1h4v1zm5.25-3H4.75V3h14.5v16z' })
  );
};
HardwareTabletAndroid = (0, _pure2.default)(HardwareTabletAndroid);
HardwareTabletAndroid.displayName = 'HardwareTabletAndroid';
HardwareTabletAndroid.muiName = 'SvgIcon';

exports.default = HardwareTabletAndroid;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui/svg-icons/hardware/tablet-android.js
// module id = 3047
// module chunks = 0